import React from 'react';
import { observer } from 'mobx-react';
import { FaqItemStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class FaqItemCreate extends React.Component {

  onCreate = title => {
    FaqItemStore.create(
      {
        data: {
          title,
          faqCategoryId: this.props.faqCategoryId,
        },
      },
      this.props.afterChange,
    );
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a FAQ title'
        onCreate={this.onCreate}
      />
    );
  }
}

export default FaqItemCreate;
